import { createMeasurementState } from "./seedVariantMeasurements.js";

const measurementValues = (source) => ({
  count: source?.count ?? "",
  tgw: source?.tgw == null ? "" : source.tgw * 1000,
  packageWeight: source?.packageWeight == null ? "" : source.packageWeight * 1000,
});

// Rebuilds the editor from a domain source. An absent source means the
// add-new form should return to its initial non-measurement fields; an
// existing source restores its persisted values instead of event properties.
export const buildSeedVariantTypeResetState = (source, initialState) => {
  const sourceFields = source ?? {};
  const fields = Object.entries(initialState).reduce((acc, [key, initialField]) => {
    const value = source == null ? initialField.value : sourceFields[key] ?? initialField.value;
    return {
      ...acc,
      [key]: {
        ...initialField,
        value,
        isValid: initialField.validate(value),
        touched: false,
      },
    };
  }, {});

  return {
    fields,
    measurements: createMeasurementState(measurementValues(source)),
  };
};
